import { Button } from "@/shared/ui/button";
import { Badge } from "@/shared/ui/badge";
import { Filter } from "lucide-react";

interface FiltersButtonProps {
  activeFiltersCount: number;
  isOpen?: boolean;
  onClick: () => void;
}

export function FiltersButton({
  activeFiltersCount,
  isOpen = false,
  onClick,
}: FiltersButtonProps) {
  const hasActiveFilters = activeFiltersCount > 0;

  return (
    <Button
      variant={isOpen || hasActiveFilters ? "secondary" : "outline"}
      size="sm"
      onClick={onClick}
      aria-pressed={isOpen}
      className="gap-2"
    >
      <Filter className="h-4 w-4" />
      Filters
      {hasActiveFilters && (
        <Badge
          variant="secondary"
          className="rounded-lg px-1.5 py-0 text-[11px]"
        >
          {activeFiltersCount}
        </Badge>
      )}
    </Button>
  );
}

